module.exports = __webpack_public_path__ + "static/media/Videobanner_joobster_gemeinderegional.477260a9.jpg";